import React, { Component } from 'react';
import history from '../../utils/history';
import session from '../../utils/session';
import urlHandler from '../../utils/urlHandler';
import FinchButton from '../demo/FinchButton';

class Query extends Component {
    constructor(props){
        super(props);

        this.onResponse = this.onResponse.bind(this);
        this.clickActions = this.clickActions.bind(this);

        this.state = {
            processing: false,
            show: false
        };
    }

    onResponse(response, arg1, http) {
        if (http !== 200 && http !== 250) {
            this.setState({
                processing: false,
                show: false,
                response: null
            });
            history.push('/error/' + http + '/' + response.error_message);
        } else {
            this.setState({
                processing: false,
                show: true,
                response
            });
        }
    }

    clickActions (){
        if(session.isAuthenticated()){

            if(this.state.processing === false && session.isAuthenticated()){
                this.setState({
                    processing: true,
                    show: false,
                    response: null
                });
            }

            if (!this.state.show) {
                urlHandler.sendRequest(this.props.query, this.props.example, this.props.stated,this.props.txt, null, this.onResponse);
            }else{
                this.setState({
                    processing: false,
                    show: false
                });
            }
        }
    }

    render() {
        const responseText = JSON.stringify(this.state.response, null, '    ');
        const queryResponse = session.isAuthenticated()===true;

        return (
            <div>
                {this.props.response ?
                    <div>
                        <h4 className="subheader2">Response</h4>
                        <div className='example-query-response'>
                            <code id='text'>
                                <pre>{JSON.stringify(JSON.parse(this.props.response), null, 3)}</pre>
                            </code>
                        </div>                
                    </div>
                :
                    <div className='example-query-wrapper'>
                        <br/>
                        <span>
                            <FinchButton primary={true} processing = {this.state.processing} inactive={!session.isAuthenticated()} warning = {true} text = {this.state.show?'Hide Response':'Show Response'}  submit={this.clickActions}/>
                            <div className="postman-link"><a href="/documentation/doc_postman">Download Postman examples</a></div>
                            <span className='user-warning' hidden={queryResponse ? true:false}> You need to be logged in to see API Examples</span>
                        </span>
                        {this.state.show &&
                            <div className='example-query-response'>
                                <code id='text'>
                                    <pre>{JSON.stringify(this.state.response, null, 3)}</pre>
                                </code>
                            </div>
                        }
                    </div>           
                }   
            </div>

        );
    }

}

export default Query;